import { render, staticRenderFns } from "./DashboardCustomQuestionsTable.vue?vue&type=template&id=6189d51b"
import script from "./DashboardCustomQuestionsTable.vue?vue&type=script&lang=js"
export * from "./DashboardCustomQuestionsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports